import { motion } from 'motion/react';

import { useLanguage, useTranslation } from '../i18n/hooks';

export default function QualityPrivacySection() {
  const t = useTranslation();
  const { direction } = useLanguage();

  return (
    <motion.section
      id="quality-privacy"
      className="overflow-x-hidden bg-white px-4 py-10 sm:px-6 md:px-8 lg:px-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-6 lg:relative lg:flex-row">
        {/* Quality Card */}
        <motion.div
          className={`flex-1 rounded-3xl p-10 text-white ${direction === 'rtl' ? 'text-right' : 'text-left'}`}
          style={{ backgroundColor: '#D9BA6A' }}
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
          whileHover={{
            scale: 1.02,
            boxShadow: '0 20px 40px rgba(217, 186, 106, 0.3)',
          }}
        >
          <motion.h3
            className="mb-6 text-3xl font-semibold"
            style={{
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '1.2em',
            }}
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {t.qualityPrivacy.title}
          </motion.h3>
          <div className="space-y-3">
            {t.qualityPrivacy.features.map((text, index) => (
              <motion.div
                key={index}
                className="rounded-md bg-white/10 p-3"
                style={{ width: '638px', maxWidth: '100%' }}
                initial={{ x: -30, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}
              >
                <p
                  className="leading-relaxed text-white"
                  style={{
                    fontFamily: 'Almarai',
                    fontWeight: 700,
                    fontSize: '20px',
                    lineHeight: '1.2em',
                    textAlign: direction === 'rtl' ? 'right' : 'left',
                  }}
                >
                  {text}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Image Card */}
        <motion.div
          className={`relative mx-auto h-[340px] w-full max-w-[336px] overflow-hidden rounded-3xl lg:absolute lg:top-7 ${direction === 'rtl' ? 'lg:left-7' : 'lg:right-7'}`}
          style={{ flexShrink: 0 }}
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
          whileHover={{ scale: 1.02 }}
        >
          {/* Background Frame */}
          <div className="absolute inset-0 m-10">
            <div
              className="h-full w-full rounded-xl"
              style={{ backgroundColor: '#F8F8F8' }}
            />
          </div>

          {/* Image Circle */}
          <motion.div
            className="absolute"
            style={{
              width: '516px',
              height: '516px',
              left: '-76px',
              top: '-73px',
              borderRadius: '50%',
              overflow: 'hidden',
            }}
            initial={{ scale: 1.2, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.4, duration: 1, ease: 'easeOut' }}
            viewport={{ once: true }}
          >
            <img
              src="/images/quality-section-bg.png"
              alt={t.qualityPrivacy.imageAlt}
              // width={516}
              // height={516}
              className="h-full w-full object-cover"
            />
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
}
